export class ParametroAzureAcsModel {
  id?: number;
  endpoint?: string;
  apelido?: string;
  accessKey?: string;
  emailRemetente?: string;
  limiteHorario?: number;
  limiteMinuto?: number;
  valorUnitarioMsg?: number;
  moedaCusto: 'BRL' | 'USD' | 'EUR' = 'USD';
  usuario?: string;
  senha?: string;
  ativo?: boolean;
}
